import GalleryFiles from "./GalleryFiles";

export default GalleryFiles;
